<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t('superviseur.profil.title') }}</h2>
    </div>

    <el-card class="box-card" style="max-width: 640px;">
      <p>{{ $t('superviseur.profil.description') }}</p>

      <div v-if="signatureUrl" class="signature-preview">
        <img :src="signatureUrl" alt="signature">
      </div>
      <el-alert
        v-else
        :title="$t('superviseur.profil.noSignature')"
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 16px;"
      />

      <el-upload
        ref="upload"
        action="#"
        :auto-upload="false"
        :show-file-list="false"
        accept="image/png,image/jpeg,image/jpg"
        :on-change="handleFileChange"
      >
        <el-button type="primary" icon="el-icon-upload">
          {{ $t('superviseur.profil.chooseFile') }}
        </el-button>
      </el-upload>

      <el-button
        type="success"
        style="margin-left: 12px;"
        :loading="saving"
        :disabled="!selectedFile"
        @click="uploadSignature"
      >
        {{ $t('superviseur.profil.save') }}
      </el-button>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { saveControleurSignature } from '@/api/superviseur';

export default {
  name: 'SuperviseurProfilSignature',
  data() {
    return {
      selectedFile: null,
      saving: false,
    };
  },
  computed: {
    ...mapGetters(['controleur']),
    signatureUrl() {
      return this.controleur ? this.controleur.signature : null;
    },
    controleurId() {
      return this.controleur ? this.controleur.id : null;
    },
  },
  methods: {
    handleFileChange(file) {
      this.selectedFile = file.raw;
    },
    async uploadSignature() {
      if (!this.controleurId || !this.selectedFile) {
        return;
      }
      const formData = new FormData();
      formData.append('fichier', this.selectedFile);
      this.saving = true;
      try {
        await saveControleurSignature(this.controleurId, formData);
        this.$message.success(this.$t('superviseur.profil.saved'));
        await this.$store.dispatch('user/getInfo');
        this.selectedFile = null;
      } catch (error) {
        console.error(error);
        this.$message.error(this.$t('general.errorOccurred'));
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.signature-preview {
  margin: 16px 0;
  padding: 12px;
  border: 1px dashed #dcdfe6;
  text-align: center;
}
.signature-preview img {
  max-width: 240px;
  max-height: 120px;
}
</style>
